import { render, staticRenderFns } from "./TextAlignCenterVIcon.vue?vue&type=template&id=e05fcbba&"
import script from "./TextAlignCenterVIcon.vue?vue&type=script&lang=js&"
export * from "./TextAlignCenterVIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports